module.exports = __webpack_public_path__ + "img/vivo.f3a5819b.png";